import axios from 'axios'
import {serialize} from '../../../core/_util'
const API_URL = process.env.REACT_APP_BASE_API_URL

const CREATE_CONTACT = `${API_URL}/contacts`
const GET_CONTACT_GROUPS = `${API_URL}/contact`
const GET_ALL_EVENT = `${API_URL}/events`
const CREATE_EVENT = `${API_URL}/events`
const GET_USER_INFO = `${API_URL}/userInfo`
const GET_MAILERS = `${API_URL}/mailer`
const TIME_ZONE = `${API_URL}/user-meta/timezone`
const GET_ALL_EMAILS = `${API_URL}/emails`
const CREATE_MAIL = `${API_URL}/email`
const GENERATE_EMAIL_WITH_AI = `${API_URL}/ai-email-compose`

export const getMailers = (companyId: number) => {
  return axios.get(`${GET_MAILERS}/${companyId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getUserTimezone = (companyId: number) => {
  return axios.get(`${TIME_ZONE}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getContacts = (companyId: number, pageToken = '') => {
  return axios.get(`${CREATE_CONTACT}`, {
    headers: {
      'x-company-id': companyId,
    },
    params: pageToken ? {page_token: pageToken} : {},
    validateStatus(status) {
      return true
    },
  })
}

export const getEvents = (companyId: number, startEpoch: number, endEpoch: number) => {
  return axios.get(`${GET_ALL_EVENT}`, {
    headers: {
      'x-company-id': companyId,
    },
    params: {
      startTime: `${startEpoch}`,
      endTime: `${endEpoch}`,
      limit: 200,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getContactGroups = (companyId: number) => {
  return axios.get(`${GET_CONTACT_GROUPS}/groups`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getUserInfo = (companyId: number) => {
  return axios.get(`${GET_USER_INFO}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const createContact = (companyId: number, payload: any) => {
  return axios.post(`${CREATE_CONTACT}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const createEvent = (companyId: number, payload: any) => {
  return axios.post(`${CREATE_EVENT}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const updateContact = (companyId: number, payload: any, contactId: any) => {
  return axios.post(`${CREATE_CONTACT}/${contactId}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const updateEvent = (companyId: number, payload: any, eventId: any) => {
  return axios.post(`${CREATE_EVENT}/${eventId}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const deleteContact = (companyId: number, contactId: any) => {
  return axios.delete(`${CREATE_CONTACT}/${contactId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const deleteEvent = (companyId: number, eventId: any) => {
  return axios.delete(`${CREATE_EVENT}/${eventId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getAllEmail = (
  companyId: number,
  page: number,
  size: number,
  status: string,
  search: string,
  sortBy?: string,
  sortOrder?: string,
  threadId?: string
) => {
  const object = {
    page,
    size,
    status,
    search,
    sort_by: sortBy,
    sort_order: sortOrder,
    thread_id: threadId,
  }
  return axios.get(`${GET_ALL_EMAILS}?${serialize(object)}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const createMessage = (companyId: number, payload: any) => {
  return axios.post(`${CREATE_MAIL}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const updateMessage = (companyId: number, emailId: string, payload: any) => {
  return axios.post(`${CREATE_MAIL}/${emailId}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getEmail = (companyId: number, emailId: string, status?: string) => {
  const object = {
    status,
  }
  return axios.get(`${CREATE_MAIL}/${emailId}?${serialize(object)}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const deleteEmails = (companyId: number, payload: any) => {
  return axios.delete(`${CREATE_MAIL}`, {
    headers: {
      'x-company-id': companyId,
    },
    data: payload,
    validateStatus(status: any) {
      return true
    },
  })
}

export const markedStarred = (companyId: number, emailId: string, payload: any) => {
  return axios.post(`${CREATE_MAIL}/star/${emailId}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}
export const markedRead = (companyId: number, payload: any) => {
  return axios.post(`${CREATE_MAIL}/read`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const createAiComposeEmail = (companyId: number, payload: any, format?: string) => {
  const object = {
    format,
  }
  return axios.post(`${GENERATE_EMAIL_WITH_AI}?${serialize(object)}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}
